/* global angular */
( function () {
	'use strict';

	/* eslint-disable max-params */
	function Group ( $scope, dataservice, collectionService, $modal, groupIndexService, deepLoadingStatusService, apiService, TOOLTIP_MESSAGES, templateHolder, authService ) {
		/* eslint-enable max-params */
		var self     = this;
		var selected = [];
		var tempName;

		function templateAttachmentMapper ( item ) {
			return {
				'ContentName' : item.name || item.ContentName,
				'ContentId'   : item.id || item.ContentId,
				'type'        : item.type || 1
			};
		}

		function updateSelectedPd ( selectedPd ) {
			selected         = selectedPd;
			self.numberOfPPD = selected.length;
			self.model.templateAttachments = selected.map( templateAttachmentMapper );
		}

		function pdOnly ( item ) {
			// making sure that we only count PD in templateAttachments
			return item.hasOwnProperty( 'ContentId' ) || item.fileType === 19;
		}

		function currentGroupIndex () {
			return groupIndexService.getIndex();
		}

		function setGroupIndex ( index ) {
			groupIndexService.setIndex( index );
		}

		function saveHandler () {
			self.mode = 'view';
		}

		function editHandler () {
			self.mode = 'edit';
		}

		function removeIndicatorHandler ( indicator ) {
			collectionService.removeModel( self.model.indicators, indicator );
		}

		function activate () {
			var indicatorLen = ( ( self.model || {} ).indicators || [] ).length;

			self.firstLoad    = true;
			self.isValidGroup = true;

			if ( indicatorLen ) {
				deepLoadingStatusService.incrementLoading( indicatorLen, 'indicator' );
			}

			deepLoadingStatusService.decrementLoading( null, 'group' );
		}

		function setState ( focus, state, array, override ) {
			if ( override && array && array.length ) {
				array[ array.length - 1 ].state = false;
			} else {
				( focus || {} ).state = state;
			}
		}

		function arrayMapper ( focus ) {
			setState( focus, true );
		}

		function clearState ( array ) {
			( array || [] ).map( arrayMapper );
		}

		function booleanReset ( array, focus, override ) {
			clearState( array );
			setState( focus, false, array, override );
		}

		function addReset ( isLast, staticCount, allStates ) {
			if ( isLast && staticCount.current <= allStates.length && !self.firstLoad ) {
				booleanReset( allStates, null, true );
				staticCount.current = allStates.length;
			}
		}

		function openConfirmationModal () {
			$modal.open( {
				'templateUrl'  : '/templates/components/delete-modal/delete-confirmation.html',
				'controller'   : 'DeleteConfirmationController',
				'controllerAs' : 'vm',
				'resolve'      : {
					'type' : function () {
						return 'Group';
					}
				}
			} ).result.then( function () {
				self.onDelete();
			} );
		}

		function isValidGroupName () {
			var isValidRegExp = new RegExp( '[^ ]' );

			self.isValidGroup = isValidRegExp.test( self.model.groupName );
			$scope.groupForm.groupname.$setValidity( 'validGroupName', self.isValidGroup );

			return self.isValidGroup;
		}

		function alterTemplateFormula ( oldId, newId ) {
			templateHolder.alter( function ( templateModel ) {
				templateModel.formula = ( templateModel.formula || '' ).split( oldId ).join( newId );
			} );
		}

		function changeId () {
			var prevId = self.model.id;

			self.model.id = apiService.generateUUID();

			alterTemplateFormula( prevId, self.model.id );
		}

		function currentGroupName ( groupName ) {
			tempName = groupName;
		}

		function testGroupName () {
			if ( typeof self.model.groupName === 'undefined' || self.model.groupName.trim().length === 0 ) {
				self.model.groupName = tempName;
			}

			tempName = self.model.groupName;
		}

		self.saveHandler            = saveHandler;
		self.editHandler            = editHandler;
		self.removeIndicatorHandler = removeIndicatorHandler;
		self.clearState             = clearState;
		self.booleanReset           = booleanReset;
		self.addReset               = addReset;
		self.openConfirmationModal  = openConfirmationModal;
		self.currentGroupIndex      = currentGroupIndex;
		self.setGroupIndex          = setGroupIndex;
		self.isValidGroupName       = isValidGroupName;
		self.testGroupName          = testGroupName;
		self.currentGroupName       = currentGroupName;
		self.changeId               = changeId;
		self.isViewOnlyMode         = authService.isViewOnlyMode();
		self.updateSelectedPd       = updateSelectedPd;
		self.pdOnly                 = pdOnly;
		self.tooltip                = TOOLTIP_MESSAGES;

		activate();
	}

	angular
		.module( 'app.templates' )
		.controller( 'Group', Group );

	Group.$inject = [ '$scope', 'coreservice', 'collectionService', '$modal', 'groupIndexService', 'deepLoadingStatusService', 'apiService', 'TOOLTIP_MESSAGES', 'templateHolder', 'authService' ];
} )( );
